module.exports = __webpack_public_path__ + "static/logo-9357a8fb57a9ee790ee262d135fd3c2d.png";